// src/services/paymentAccountsService.js
import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

export const paymentAccountsService = {

  // ✅ Get all payment accounts
  getAll: async (filters = {}) => {
    try {
      const response = await apiClient.get(ENDPOINTS.PAYMENT_ACCOUNTS.GET_ALL, { params: filters });
      return response;
    } catch (error) {
      console.error('Failed to fetch payment accounts:', error);
      throw error;
    }
  },

  // ✅ Get payment account by ID
  getById: async (id) => {
    try {
      const response = await apiClient.get(ENDPOINTS.PAYMENT_ACCOUNTS.GET_BY_ID(id));
      return response;
    } catch (error) {
      console.error(`Failed to fetch payment account ${id}:`, error);
      throw error;
    }
  },

  // ✅ Create new payment account
  create: async (data) => {
    try {
      const response = await apiClient.post(ENDPOINTS.PAYMENT_ACCOUNTS.CREATE, data);
      return response;
    } catch (error) {
      console.error('Failed to create payment account:', error);
      throw error;
    }
  },

  // ✅ Update payment account
  update: async (id, data) => {
    try {
      const response = await apiClient.put(ENDPOINTS.PAYMENT_ACCOUNTS.UPDATE(id), data);
      return response;
    } catch (error) {
      console.error(`Failed to update payment account ${id}:`, error);
      throw error;
    }
  },

  // ✅ Delete payment account
  delete: async (id) => {
    try {
      const response = await apiClient.delete(ENDPOINTS.PAYMENT_ACCOUNTS.DELETE(id));
      return response;
    } catch (error) {
      console.error(`Failed to delete payment account ${id}:`, error);
      throw error;
    }
  },
};

export default paymentAccountsService;
